import React from 'react'
import { Link, Router } from 'react-router-dom'
import PostCard from '../../components/PostCard/PostCard'
import RouterButton from '../../components/RouterButton/RouterButton'
import './PostsSection.scss'

function PostsSection(props) {

  return (
    <div className='post-section'>
      <RouterButton to={"/reviews"}>
        <h2>Game Reviews</h2>
      </RouterButton>
      <div className='post-section-content'>
      <div className='post-last'>
        {
          props.posts[0] != null && <PostCard key={props.posts[0].id} post={props.posts[0]} />
        }

      </div>
      <div className='posts-vertical'>
        {
          props.posts[1] != null && <PostCard key={props.posts[1].id} post={props.posts[1]} />
        }
        {
          props.posts[2] != null && <PostCard key={props.posts[2].id} post={props.posts[2]}/>
        }
      </div>
      </div>
      


    </div>

  )
}

export default PostsSection